import React, { useEffect, useState } from 'react';
import { Select, SelectOption, SelectValue, TableRowData } from 'tdesign-react';

import { HomeDataManagerType } from '@/const/promotion';
import { ISpace, IStory } from '@/interface';
import { IPromotionItemInput, OthersData, Story } from '@/interface/promotion';

import { ChangeDataType, fetchStoryOptions, formKeys } from '../custom-index/config';
import styles from './index.module.less';
import List from './list';

export const CustomStoryComponent: React.FC<{
  value: Story;
  parentData?: IPromotionItemInput;
  onChange: (key: Story) => void;
}> = (props) => {
  const { parentData } = props || {};
  const values = parentData?.stories || props.value;
  const [compValue, setCompValue] = useState<Story['story']>([]);
  const [storyOptions, setStoryOptions] = useState<SelectOption[]>([]);

  const spaceId = parentData?.space?.id || (parentData?.space as { opt?: ISpace })?.opt?.id;
  useEffect(() => {
    fetchStoryOptions({ spaceId }).then((res) => {
      const { list } = res;
      setStoryOptions(list);
    });
  }, [spaceId]);

  useEffect(() => {
    setCompValue(values?.story);
  }, [values]);

  const moveStory = (id: string) => {
    const story = compValue ? [...compValue] : [];
    const ids = story.map(item => item.id);
    const index = ids.findIndex(item => item === id);
    const others = values?.others?.filter((e: OthersData) => e.id !== id);
    story.splice(index, 1);
    props.onChange({ ...props.value, story, others });
  };

  const listDataChange = (data: TableRowData) => {
    props.onChange({ ...props.value, [formKeys.story]: data });
  };

  const othersChange = (data: OthersData[]) => {
    props.onChange({ ...props.value, [formKeys.others]: data });
  };

  const changeData = (type: number, values?: Story['story']) => {
    if (type === ChangeDataType.INPUT) {
      return (values)?.map(e => (e as unknown as { opt: IStory }).opt);
    }
    if (type === ChangeDataType.OUTPUT) {
      return values?.map(e => ({ label: e?.name, value: e?.id, opt: e }));
    }
  };

  const story = changeData(ChangeDataType.OUTPUT, compValue);
  const alone = parentData?.managerType === HomeDataManagerType.HOMEDATAMANAGERTYPE_RECOMMEND;

  const handleChangeSelect = (prop: string, value: SelectValue) => {
    let tempValue = alone ? [value] : value;
    if (prop === formKeys.story) {
      tempValue = (changeData(ChangeDataType.INPUT, tempValue as Story['story'])) as Story;
    }
    props.onChange({ ...props.value, [prop]: tempValue });
  };

  const storyValue = alone ? story?.[0] : story;

  return (
    <div className={styles.wrapper}>
      <Select
        className={styles.botSelect}
        value={storyValue}
        filterable
        onChange={value => handleChangeSelect(formKeys.story, value)}
        options={storyOptions}
        disabled={false}
        multiple={!alone}
        valueType='object'
      />
      <div className={styles.table}>
        <List
          data={compValue}
          othersData={props.value?.others}
          managerType={parentData?.managerType}
          moveStory={moveStory}
          onChange={listDataChange}
          othersChange={othersChange}
        />
      </div>
    </div>
  );
};
